import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const heroBg =
  "https://readdy.ai/api/search-image?query=A%20modern%20bright%20architect%20seminar%20room%20interior%20with%20natural%20light%20streaming%20through%20large%20floor-to-ceiling%20windows%2C%20minimalist%20white%20and%20warm%20wood%20tones%2C%20architectural%20blueprints%20on%20a%20long%20table%2C%20professional%20atmosphere%2C%20high-end%20conference%20space%2C%20soft%20golden%20hour%20lighting%2C%20clean%20contemporary%20design%2C%20photographic%20style%2C%20editorial%20quality&width=1600&height=900&seq=1&orientation=landscape";

export default function HeroSection() {
  const { t } = useTranslation();
  const tags = [
    "免費講座",
    "120 分鐘重點解析",
    "土地 × 預算 × 法規 × 工法",
    "適合自地自建與危老重建族群",
  ];

  return (
    <section className="relative min-h-[80vh] md:min-h-[85vh] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={heroBg}
          alt="現代建築師講座空間"
          className="w-full h-full object-cover object-top"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-graphite/75 via-graphite/60 to-graphite/85" />
      </div>

      <div className="relative z-10 w-full container-main px-4 md:px-8 lg:px-12 py-28 md:py-36">
        <div className="max-w-3xl">
          <span className="tag-label mb-5 inline-block">{t("seminars.hero.label")}</span>
          <h1 className="text-white mb-5">{t("seminars.hero.title")}</h1>
          <p className="text-cream/90 mb-8 max-w-2xl">{t("seminars.hero.subtitle")}</p>

          <div className="flex flex-wrap gap-2.5 mb-10">
            {tags.map((tag) => (
              <span
                key={tag}
                className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-base font-sans font-medium bg-white/10 text-cream/95 border border-white/15"
              >
                <i className="ri-check-line text-champagne" />
                {tag}
              </span>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="https://lin.ee/OpssTIM"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary gap-2 text-[1.0625rem]"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-line-fill" />
              </span>
              {t("seminars.hero.cta")}
            </a>
            <Link
              to="/process"
              className="btn-outline border-white/30 text-white hover:bg-white hover:text-graphite text-[1.0625rem]"
            >
              {t("common.readMore")}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}